module.exports = __webpack_public_path__ + "static/media/ndb.0007b23e.jpg";